// Translated from the English source with an external model, then reviewed. Regenerate with
// scripts/import-translation-bundle.ts rather than editing by hand — a hand edit here is lost
// the next time a bundle comes back.

export const ACHIEVEMENT_TRANSLATIONS_DE = {
  "never-empty-handed": {
    "name": "Nie mit leeren Händen",
    "description": "Fishing-Hobby erreicht Stufe 10",
    "titleGained": "Erfahrener Angler",
  },
  "mystic-fisher": {
    "name": "Mystischer Angler",
    "description": "Löse die verborgene Phase des Fishing-Events insgesamt 10-mal aus.",
    "titleGained": "Angler",
  },
  "shoals-blessing": {
    "name": "Shoal's Segen",
    "description": "Löse während Fishing-Events insgesamt 100 Shoals aus.",
    "titleGained": "Segen",
  },
  "strong-sailor": {
    "name": "Stark Sailor",
    "description": "Fange zweimal hintereinander Fische mit mehr als 100 kg.",
    "titleGained": "Angelschnur",
  },
  "twin-fish-fortune": {
    "name": "Twin Fische Fortune",
    "description": "Fange 2 Fische mit 5★ innerhalb von 1 Minute.",
    "titleGained": "Fischadler",
  },
  "fishing-machine": {
    "name": "Fishing-Maschine",
    "description": "Fangen ein insgesamt von 50 Fische über 100kg jeweils.",
    "titleGained": "Fischkorb",
  },
  "shark-frenzy": {
    "name": "Hai-Raserei",
    "description": "Fange 3 Haie mit goldenen Fischschatten während eines einzelnen Sea-Fishing-Events.",
    "titleGained": "Hai Cage",
  },
  "shoal-caller": {
    "name": "Schwarmrufer",
    "description": "Löse 3 Shoals in einem einzelnen Fishing-Event aus.",
    "titleGained": "Schwarmrufer",
  },
  "starlight-fisher": {
    "name": "Sternenlicht-Angler",
    "description": "Fange 4 Fische mit 5★ in einem einzelnen Fishing-Event.",
    "titleGained": "Fishing-Maniac",
  },
  "town-cooking-legend": {
    "name": "Kochlegende der Stadt",
    "description": "Das Cooking-Hobby erreicht Stufe 10.",
    "titleGained": "Koch",
  },
  "fast-and-flawless": {
    "name": "Schnell und fehlerfrei",
    "description": "Koche 2 Gerichte mit 5★ innerhalb von 60 Sekunden.",
    "titleGained": "Küchenuhr",
  },
  "green-touch": {
    "name": "Grüner Daumen",
    "description": "Das Gardening-Hobby erreicht Stufe 10.",
    "titleGained": "Gärtner",
  },
  "plentiful-harvest": {
    "name": "Plentiful Ernte",
    "description": "Ernte 5★-Feldfrüchte, während Bonus-Ernte aktiv ist.",
    "titleGained": "Ernte",
  },
  "rainbow-luck": {
    "name": "Regenbogen Luck",
    "description": "Auslösen 2 Regenbogen Hybrid Blessings in ein einzeln multi-Gebiet Bewässern.",
    "titleGained": "Regenbogen Luck",
  },
  "ace-cat-servant": {
    "name": "Ace Katze Servant",
    "description": "Das Katzenpflege-Hobby erreicht Stufe 10.",
    "titleGained": "Katze Lover",
  },
  "meow-meow-canteen": {
    "name": "Miau-Miau-Kantine",
    "description": "Füttern 5 Katzen ihr Lieblings- Futter.",
    "titleGained": "Katze Futter",
  },
  "ace-dog-trainer": {
    "name": "Ace Hund Trainer",
    "description": "Das Hundepflege-Hobby erreicht Stufe 10.",
    "titleGained": "Hund Pal",
  },
  "doggie-canteen": {
    "name": "Hunde-Kantine",
    "description": "Füttern 3 Hunde ihr Lieblings- Futter.",
    "titleGained": "Hund Futter",
  },
  "insect-commander": {
    "name": "Insekt Kommandant",
    "description": "Das Bug-Catching-Hobby erreicht Stufe 10.",
    "titleGained": "Insekt Meister",
  },
  "mystic-tracker": {
    "name": "Mystischer Tracker",
    "description": "Löse die verborgene Phase des Insektenfang-Events insgesamt 10-mal aus.",
    "titleGained": "Erkundung",
  },
  "swarm-commander": {
    "name": "Schwarm Kommandant",
    "description": "Löse während Insektenfang-Events insgesamt 100 Schwärme aus.",
    "titleGained": "Schwarm",
  },
  "insect-harvester": {
    "name": "Insekt Harvester",
    "description": "Fangen 3 Insekten mit ein einzeln insect-catching bubble.",
    "titleGained": "Triple Fangen",
  },
  "five-insects-blessing": {
    "name": "Five Insekten Segen",
    "description": "Fange 5 Insekten mit 5★ während eines einzelnen Insektenfang-Events.",
    "titleGained": "Insekt Lord",
  },
  "human-insect-attractor": {
    "name": "Human Insekt Attractor",
    "description": "Löse 4 Schwärme in einem einzelnen Insektenfang-Event aus.",
    "titleGained": "Insekt Attractor",
  },
  "bird-whisperer": {
    "name": "Vogel Whisperer",
    "description": "Das Birdwatching-Hobby erreicht Stufe 10.",
    "titleGained": "Vogel Whisperer",
  },
  "cloud-walker": {
    "name": "Wolkenläufer",
    "description": "Löse die verborgene Phase des Birdwatching-Events insgesamt 10-mal aus.",
    "titleGained": "Himmel",
  },
  "harmony-with-breeze": {
    "name": "Harmonie mit Breeze",
    "description": "Löse während Birdwatching-Events insgesamt 100 Vogelwellen aus.",
    "titleGained": "Resonanz",
  },
  "joyful-chorus": {
    "name": "Fröhlicher Chor",
    "description": "Löse 3 Vogelwellen in einem einzelnen Birdwatching-Event aus.",
    "titleGained": "Feder",
  },
  "decisive-moment": {
    "name": "Entscheidender Moment",
    "description": "Erhalte 10 Info-Karten mit 5★ in einem einzelnen Birdwatching-Event.",
    "titleGained": "Augenblick",
  },
  "sand-sculpture-artist": {
    "name": "Sand-Skulpturkünstler",
    "description": "Das Sand-Sculpting-Hobby erreicht Stufe 5.",
    "titleGained": "Sandbildhauer",
  },
  "pumpkinarchy": {
    "name": "Kürbisarchie",
    "description": "Das Pumpkin-Carving-Hobby erreicht Stufe 5.",
    "titleGained": "Kürbiskopf",
  },
  "snow-king": {
    "name": "Schnee King",
    "description": "Das Schnee-Sculpting-Hobby erreicht Stufe 5.",
    "titleGained": "Schnee King",
  },
  "collector": {
    "name": "Sammler",
    "description": "Become ein Expert Sammler.",
    "titleGained": "Sammler",
  },
  "rocket-sponsor": {
    "name": "Raketen-Sponsor",
    "description": "Verdienen ein insgesamt von 500,000 Gold von selling Gegenstände zu Gold Merchant Albert Jr.",
    "titleGained": "Rakete",
  },
  "dg-member": {
    "name": "D.G. Mitglied",
    "description": "D.G. Mitglied Stufe erreicht Lv. 30.",
    "titleGained": "D.G. Mitglied",
  },
  "puzzle-artist": {
    "name": "Rätsel Artist",
    "description": "Become ein Rätsel Artist.",
    "titleGained": "Rätsel",
  },
  "persistent-quill": {
    "name": "Beharrlicher Federkiel",
    "description": "Writing Traum erreicht Meister.",
    "titleGained": "Schreiben",
  },
  "golden-music-cd": {
    "name": "Golden Musik CD",
    "description": "Musik Traum erreicht Golden Musik CD.",
    "titleGained": "Musik",
  },
  "animal-neighbour": {
    "name": "Tier Neighbour",
    "description": "Erreichen Bindung Stufe 10 mit 8 Tier Gruppen.",
    "titleGained": "Neu Neighbour",
  },
  "stardust-collector": {
    "name": "Stardust Sammler",
    "description": "Erheben 60 Starfall Shards.",
    "titleGained": "Sternensammler",
  },
  "animal-keeper": {
    "name": "Tier Keeper",
    "description": "Entdecken der Lieblings- foods für 8 Tier Gruppen.",
    "titleGained": "Lecker",
  },
  "ice-elf": {
    "name": "Eis Elf",
    "description": "Figure Skating Traum raches Eis Elf.",
    "titleGained": "Eis Skating",
  },
  "mystery-onsen-buddy": {
    "name": "Onsen-Kumpel",
    "description": "Betreten der Onsen mit ein Freund.",
  },
  "mystery-friendship-under-the-meteor": {
    "name": "Freundschaft Unter der Meteo-",
    "description": "Bei Freundschaft Lv. 5, verwenden der Wish Emote mit ein Freund während Meteorschauer Wetter.",
  },
  "mystery-super-star": {
    "name": "Superstar",
    "description": "Obtain 100 likes auf dein Startseite.",
  },
  "mystery-repair-expert": {
    "name": "Reparaturexperte",
    "description": "Teilen 100 repair kits.",
  },
  "mystery-food-diplomat": {
    "name": "Futter Diplomat",
    "description": "Teilen Futter 100 Mal.",
  },
  "mystery-wholesaler-of-grasslands": {
    "name": "Wholesaler von Grasslands",
    "description": "Teilen camouflage bush 100 Mal.",
  },
  "mystery-insect-hunting-party": {
    "name": "Insekt Hunting Party",
    "description": "Teilen inflated Insekt attractor 100 Mal.",
  },
  "mystery-rainbow-volunteer": {
    "name": "Regenbogen Volunteer",
    "description": "Teilen Regenbogen bouquet 50 Mal.",
  },
  "onsen-buddy": {
    "name": "Onsen-Kumpel",
    "description": "Take ein Onsen mit Freunde.",
    "titleGained": "Onsen",
    "hint": "Admist der swirling steam, Freundschaft quietly deepens.",
  },
  "mystery-best-selling-author": {
    "name": "Beste Selling Author",
    "description": "Verkaufen ein insgesamt von 1000 books.",
  },
  "mystery-great-author": {
    "name": "Großartig Author",
    "description": "Write bei least 10 books, jeweils mit 200 sales.",
  },
  "mystery-bookcase-full": {
    "name": "Bookcase Vollständig (Unconfirmed)",
    "description": "Unconfirmed: Hinweis mentions dein bookcase getting vollständig.",
  },
  "mystery-sea-fishing-grand-slam": {
    "name": "Sea-Fishing-Grand-Slam",
    "description": "Erhalte alle End-of-Event-Titel des täglichen Sea-Fishing-Events.",
  },
  "mystery-onsen-mountain-insect-hunter": {
    "name": "Onsen Berg Insekt Hunter",
    "description": "Erheben alle end-of-Event titles von der Köder der Insekten Tages-Event.",
  },
} as const;
